import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _6FtApartIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"6_ft_apart"} ref={ref}/>
});

_6FtApartIcon.displayName = "_6FtApartIcon";
